
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { format } from "date-fns";
import { fr } from "date-fns/locale";

interface NextPeriodInfoProps {
  nextPeriod: Date;
}

export const NextPeriodInfo = ({ nextPeriod }: NextPeriodInfoProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Prochaines règles</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-lg">
          Prévues pour le {format(nextPeriod, "PPP", { locale: fr })}
        </p>
      </CardContent>
    </Card>
  );
};
